import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ccc18cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-price"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "loading-text"
}
const _hoisted_4 = {
  key: 1,
  class: "pricing-error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The selected item is currently unpriceable.", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" for availability.")

import { WebsiteItem } from '@/types'
    import { ref, PropType, watch } from 'vue'
    import priceService from '@/services/price-service'
    import { debounce } from 'lodash'
    import MailToQuotes from '@/components/MailToQuotes.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPrice',
  props: {
        item: { type: Object as PropType<WebsiteItem>, required: false, default: undefined },
        priceAdjust: { type: Number, required: false, default: 100 }
    },
  emits: ['priceError'],
  setup(__props, { emit }) {

const props = __props

    

    

    const price = ref<string>('')
    const hasError = ref<boolean>(false)
    const callCount = ref<number>(0)

    watch(() => props.item, debounce(async () => {
        hasError.value = false
        callCount.value += 1
        if(props.item) {
            const result = await priceService.getPrice(props.item) as any
            if(result.quoteRequired) {
                hasError.value = true
            } else {
                const pa = (props.priceAdjust >= 100) ? props.priceAdjust : 100
                price.value = `$${(result.price * (pa/100)).toFixed(2)}`
            }
        }
        callCount.value -= 1
    }), {immediate: true})

    watch(hasError, (current, old) => {
        emit('priceError', current)
    })

return (_ctx: any,_cache: any) => {
  return (!hasError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, [
          (callCount.value <= 0 && price.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(price.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "Loading..."))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", null, [
          _hoisted_6,
          _createVNode(MailToQuotes, { product: __props.item }, null, 8, ["product"]),
          _hoisted_7
        ])
      ]))
}
}

})